<template>
  <div
    id="recibo"
    :class="loja?.TAMANHO_IMPRESSAO !== 'A4' ? 'bobina' : 'a4'"
    :style="{
      fontSize: pageSettings.fontSize,
      width: pageSettings.width,
      padding: pageSettings.margin,
      fontFamily: 'monospace',
    }"
  >
    <!-- CABEÇALHO -->
    <div class="text-center">
      <q-avatar
        rounded
        :size="loja?.TAMANHO_IMPRESSAO === 'A4' ? '70px' : '40px'"
      >
        <img :src="loja?.LOGO ? loja.LOGO : defaultLogo" />
      </q-avatar>

      <div class="q-mt-sm">
        <strong>{{ loja?.NOME?.toUpperCase() }}</strong>
      </div>

      <div>{{ loja?.WHATSAPP }}</div>
      <div>{{ loja?.CPF_CNPJ }}</div>

      <div class="q-mt-md">
        <strong>RECIBO DE VENDA</strong>
      </div>

      <div>DOCUMENTO NÃO FISCAL</div>
    </div>

    <div class="separator"></div>

    <!-- DADOS VENDA -->
    <div><strong>DATA:</strong> {{ dateFormat(recibo.DATA) }}</div>

    <div v-if="recibo?.ID_CLIENTE">
      <strong>CLIENTE:</strong>
      {{ recibo?.NOME?.toUpperCase() }}
    </div>

    <div v-else-if="recibo?.CLIENTE">
      <strong>CLIENTE:</strong>
      {{ recibo?.CLIENTE?.toUpperCase() }}
    </div>

    <div v-if="recibo.CONDICIONAL" class="text-bold text-negative q-mt-sm">
      CONDICIONAL ATÉ:
      {{ dateFormat(recibo.PRAZO_CONDICIONAL) }}
    </div>

    <div class="separator"></div>

    <!-- PRODUTOS -->
    <div v-if="loja?.TAMANHO_IMPRESSAO !== 'A4'">
      <div
        v-for="(produto, index) in recibo.produtosVendas"
        :key="index"
        class="produto-item"
      >
        <div class="row justify-between">
          <div>
            {{
              produto.FRACIONADO
                ? parseFloat(produto.QUANTIDADE).toFixed(3)
                : parseInt(produto.QUANTIDADE)
            }}x {{ produto.UNIDADE }}
          </div>

          <div>R$ {{ Number(produto.TOTAL).toFixed(2) }}</div>
        </div>

        <div class="produto-nome">
          {{ produto.NOME.toUpperCase() }}
        </div>
      </div>
    </div>

    <!-- A4 -->
    <q-table
      v-else
      :rows="recibo.produtosVendas"
      flat
      bordered
      :columns="columns"
      hide-bottom
      :pagination="pagination"
      dense
    />

    <div class="separator"></div>

    <!-- TOTAIS -->
    <div class="totais">
      <div class="row justify-between">
        <strong>SUBTOTAL:</strong>
        <strong>R$ {{ recibo.SUB_TOTAL }}</strong>
      </div>

      <div class="row justify-between">
        <strong>DESCONTO:</strong>
        <strong>R$ {{ recibo.DESCONTO }}</strong>
      </div>

      <div class="row justify-between text-bold text-h6">
        <strong>TOTAL:</strong>
        <strong>R$ {{ recibo.TOTAL }}</strong>
      </div>
    </div>

    <div class="separator"></div>

    <!-- PAGAMENTOS -->
    <div>
      <strong>FORMA PAGAMENTO:</strong>
      {{ recibo.TIPO_PAGAMENTO }}
    </div>

    <div v-if="parseFloat(recibo.DINHEIRO) > 0">
      DINHEIRO: R$ {{ Number(recibo.DINHEIRO).toFixed(2) }}
    </div>

    <div v-if="parseFloat(recibo.PIX) > 0">
      PIX: R$ {{ Number(recibo.PIX).toFixed(2) }}
    </div>

    <div v-if="parseFloat(recibo.CARTAO_DEBITO) > 0">
      DÉBITO: R$
      {{ Number(recibo.CARTAO_DEBITO).toFixed(2) }}
    </div>

    <div v-if="parseFloat(recibo.CARTAO_CREDITO) > 0">
      CRÉDITO: R$
      {{ Number(recibo.CARTAO_CREDITO).toFixed(2) }}

      <div>
        {{ recibo.PARCELAS_CARTAO }}x de R$
        {{
          (
            Number(recibo.CARTAO_CREDITO) / Number(recibo.PARCELAS_CARTAO || 1)
          ).toFixed(2)
        }}
      </div>
    </div>

    <!-- CREDIÁRIO -->
    <div
      v-if="
        recibo.TIPO_PAGAMENTO === 'CREDIÁRIO' ||
        recibo.TIPO_PAGAMENTO === 'DUPLICATA'
      "
      class="q-mt-sm"
    >
      <div>PARCELAS: {{ recibo.PARCELAS }}</div>

      <div>VALOR PARCELA: R$ {{ recibo.VALOR_PARCELA }}</div>
    </div>

    <!-- TROCO -->
    <div v-if="parseFloat(recibo.TROCO) > 0">
      TROCO: R$ {{ Number(recibo.TROCO).toFixed(2) }}
    </div>

    <div class="separator"></div>

    <!-- RODAPÉ -->
    <div class="text-center q-mt-md">
      <div>{{ recibo.DATA }}{{ recibo.ID }}</div>

      <div class="q-mt-sm">Obrigado pela preferência!</div>

      <div class="q-mt-sm">MINI PDV - CONTROLE DE VENDAS</div>
    </div>
  </div>
</template>

<script>
import formaters from "../../../helpers/formaters";

export default {
  name: "ReciboPage",

  data() {
    return {
      recibo: {},

      loja: JSON.parse(localStorage.getItem("loja")),

      columns: [
        {
          name: "codigo",
          label: "Cod",
          field: "CODIGO_PRODUTO",
          align: "left",
        },
        {
          name: "nome",
          label: "Produto",
          field: "NOME",
          align: "left",
        },
        {
          name: "quantidade",
          label: "Qtd",
          field: "QUANTIDADE",
          align: "left",
        },
        {
          name: "valor",
          label: "Valor",
          field: "VALOR",
          align: "left",
        },
        {
          name: "total",
          label: "Total",
          field: "TOTAL",
          align: "left",
        },
      ],

      pagination: {
        rowsPerPage: 0,
      },

      pageSettings: {
        fontSize: "14px",
        margin: "10px",
        width: "100%",
      },
    };
  },

  computed: {
    defaultLogo() {
      return require("../../../../public/icons/icon-512x512.png");
    },
  },

  async created() {
    this.recibo = JSON.parse(this.$route.query.data);

    this.setFontSize();

    this.$nextTick(() => {
      this.printPage();
    });
  },

  methods: {
    printPage() {
      window.print();
    },

    dateFormat(date) {
      return formaters.receiptDate(date);
    },

    setFontSize() {
      switch (this.loja?.TAMANHO_IMPRESSAO) {
        case "50mm":
          this.pageSettings = {
            fontSize: "10px",
            margin: "2px",
            width: "48mm",
          };
          break;

        case "58mm":
          this.pageSettings = {
            fontSize: "12px",
            margin: "3px",
            width: "56mm",
          };
          break;

        case "80mm":
          this.pageSettings = {
            fontSize: "11px",
            margin: "5px",
            width: "78mm",
          };
          break;

        default:
          this.pageSettings = {
            fontSize: "14px",
            margin: "10px",
            width: "100%",
          };
          break;
      }
    },
  },
};
</script>

<style scoped>
#recibo {
  margin: 0 auto;
  color: #000;
}

.bobina {
  overflow: hidden;
}

.separator {
  border-top: 1px dashed #000;
  margin: 8px 0;
}

.produto-item {
  padding: 4px 0;
  border-bottom: 1px dashed #ccc;
}

.produto-nome {
  word-break: break-word;
  white-space: normal;
}

.totais {
  margin-top: 8px;
}

@media print {
  body {
    margin: 0;
    padding: 0;
  }

  #recibo {
    width: 100% !important;
    max-width: 100% !important;
  }

  .q-table {
    box-shadow: none !important;
  }
}
</style>
